import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid , Header , Image , Popup , Button , Table , Icon } from 'semantic-ui-react';
import { Link } from "react-router";
import ThemeColorSetting from '../../constants/themeColor';
import dPayPitchBanner from '../../assets/home/dPayPitchbanner.png';
import graphPaper from "../../assets/pattern/circuit-board.svg";

const styles = {
	coverContainer: {
    padding : '80px 0px',
		backgroundColor: '#0c1226',
    backgroundImage: 'url(' +graphPaper+ ')',
		backgroundSize : '250px 250px',
		backgroundRepeat : 'repeat'
  },
  header : {
    fontSize : '50px',
		color : '#fca311'
  },
  descriptionWrapper : {
    display : 'flex' ,
    flexDirection : 'column',
    justifyContent : 'center',
    padding : '5vh'
  },
  description : {
    fontSize : '20px',
    color : ThemeColorSetting.white,
    lineHeight: '200%'
  },
  moreFeatureButton : {
    backgroundColor : ThemeColorSetting.red,
    color : 'white' ,
    width : '20vh'
  }
}
		
class DPayPitch extends Component {
	constructor(props){
		super(props);
	}
	render(){
		const { string , mixpanel } = this.props;
		return (
      <Grid.Row columns='2' style={styles.coverContainer}>
        <Grid.Column style={styles.descriptionWrapper}>
          <Header as='h1' style={styles.header}>
						{string['dPayPitchHeader']}
					</Header>
          <p style={styles.description}>
						{string['dPayPitchContent']}
					</p>
					<Table basic='very' celled>
					 <Table.Body>
						 <Table.Row textAlign='center'>
							 <Table.Cell>
								<Header as='h3' icon inverted>
									<Icon name='print' />
									{string['instantPrint']}
								</Header>
							 </Table.Cell>
							 <Table.Cell>
								<Header as='h3' icon inverted>
									<Icon name='qrcode' />
									{string['qrCodeTransaction']}
								</Header>
							 </Table.Cell>
							</Table.Row>
						</Table.Body>
					</Table>
          <Link to={{ pathname : '/features' , query : { feature : 'dPay' } }}>
					<Button onClick={()=>mixpanel.track("dPay Page", { action : 'link to', url : "dPay Page" })} style={styles.moreFeatureButton} size={'medium'}>{string['learnTopUp']}</Button></Link>
				</Grid.Column>
				<Grid.Column>
          <Image src={dPayPitchBanner} size={'huge'}/>
        </Grid.Column>
			</Grid.Row>
		)
	}
}

function mapStateToProps(state){
	return {
		string : state.preference.string,
    mixpanel : state.ui.tempData.mixpanel
	}
}

export default connect(mapStateToProps,null)(DPayPitch)



/** WEBPACK FOOTER **
 ** ./src/containers/pitch/dPayPitch.js
 **/